import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../../../types/shared/UUID';
import { useGetCurrentSection } from '../../../../../fees/edit/useGetCurrentSection';
import { EMD_FEE_CATEGORY_DEFINITION_ID, SECTION_L_DEFINITION_ID } from '../constants';
import { IFeeData, ISettlementItemData } from '../../../../../../../types/order/fees/ISectionData';
import { eFeePropertyNames } from '../../../../../../../types/order/fees/eFeePropertyNames';

export const useGetEmdAmount = (): { emdAmount?: number } => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { currentSection } = useGetCurrentSection({ orderId, sectionDefinitionId: SECTION_L_DEFINITION_ID });

  const emdAmount = (currentSection?.statementSettlementItems ?? [])
    .flatMap(getStatementFees)
    .find(hasEmdFeeCategoryDefinition)?.numericFeePropertyValues[eFeePropertyNames.BuyerPaidAtClosing];

  return { emdAmount };
};

const getStatementFees = (settlementItem: ISettlementItemData): IFeeData[] => settlementItem.statementFees;
const hasEmdFeeCategoryDefinition = (statementFee: IFeeData): boolean =>
  statementFee.statementSettlementAndFeeCategoryDefinitionId === EMD_FEE_CATEGORY_DEFINITION_ID;
